
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vacation-rentals/[...slug]",
      function () {
        return require("private-next-pages/vacation-rentals/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vacation-rentals/[...slug]"])
      });
    }
  